export default __webpack_public_path__ + "64e07051f248da14682b1b00d6bad686.svg";